import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['onboardingLoaderVisible'] = false,
  action: Action,
): RootState['onboardingLoaderVisible'] {
  switch (action.type) {
    case 'ONBOARDING_LOADER_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
